<template>
  <div class="d-flex align-center flex-wrap" style="gap: 8px">
    <v-file-input
      v-model="selectedFile"
      label="Selecciona archivo"
      dense
      outlined
      show-size
      truncate-length="25"
      :disabled="screenData.loading"
      :clearable="!screenData.loading"
      prepend-icon="mdi-paperclip"
      :accept="acceptList"
      hide-details="auto"
      class="flex-grow-1"
      @change="autoUpload ? onFileSelected() : null"
    />
    <v-btn
      v-if="showButton"
      color="primary"
      class="text-none"
      :loading="screenData.loading"
      :disabled="!selectedFile || screenData.loading"
      @click="onClickUpload"
    >
      {{ screenData.loading ? "Subiendo..." : "Upload" }}
    </v-btn>
  </div>
</template>

<script>
import { S3Repository } from "@/modules/shared/infra/S3Repository"
import { SendKitDigitalToHubspot } from "@/modules/kit_digital/app/SendKitDigitalToHubspot"
import { HubspotKitDigitalDispatcher } from "@/modules/kit_digital/infra/HubspotKitDigitalDispatcher"
import { KitDigital } from "@/modules/kit_digital/domain/KitDigital"
import { AwsCognitoCredentialsManager } from "@/modules/shared/infra/AwsCognitoCredentialsManager"

export default {
  name: "KitDigitalUpload",

  props: {
    autoUpload: { type: Boolean, default: false },
    showButton: { type: Boolean, default: true },
    closeOnSuccess: { type: Boolean, default: true },
    screenData: { type: Object, required: true }
  },

  emits: ["snackbar", "done", "close", "loading", "screen-data"],

  data() {
    return {
      selectedFile: null,
      s3: null,
      service: null
    }
  },

  computed: {
    acceptList() {
      return KitDigital.allowedExtensions.join(",")
    }
  },

  async mounted() {
    await this.initS3()
  },

  methods: {
    async initS3() {
        if (this.s3) return

        this.service = new AwsCognitoCredentialsManager(this.$store)
        const aws = await this.service.initAWS()

        if (aws) {
          this.s3 = new S3Repository(aws, "kit_digital_excel")
        }
    },

    async uploadToS3(file) {
      await this.service.ensureAwsCreds()
      return await this.s3.uploadFile(file)
    },

    sendKitDigitalToHubspot(keyPath) {
      return new SendKitDigitalToHubspot(
        new KitDigital(keyPath),
        new HubspotKitDigitalDispatcher()
      ).execute()
    },

    async onFileSelected() {
      if (!this.autoUpload) return
      if (!this.selectedFile) return
      if (this.screenData && this.screenData.loading) return
      await this.onClickUpload()
    },

    async onClickUpload() {
      if (!this.selectedFile) {
        this.$emit("snackbar", { type: "error", text: "Selecciona un archivo primero." })
        return
      }

      this.$emit("screen-data", { path: null, loading: true })
      this.$emit("loading", true)

      try {
        const pathKey = await this.uploadToS3(this.selectedFile)
        this.$emit("screen-data", { path: pathKey, loading: true })
        await this.sendKitDigitalToHubspot(pathKey)
        this.$emit("snackbar", { type: "success", text: "Archivo enviado a HubSpot." })
        this.$emit("done", { path: pathKey })
        if (this.closeOnSuccess) this.$emit("close")
        this.selectedFile = null
      } catch {
        this.$emit("snackbar", { type: "error", text: "Error al enviar a HubSpot." })
      } finally {
        this.$emit("screen-data", {
          path: (this.screenData && this.screenData.path) ? this.screenData.path : null,
          loading: false
        })
        this.$emit("loading", false)
      }
    }
  }
}
</script>
